import { Limited, LimitEnable, LimitMode, LimitStatus } from '@EcamModel/model/SP111Limit';
import LoadingTextSkeleton from '@components/skeleton/LoadingTextSkeleton';
import { Divider, Stack } from '@mui/material';
import { useCameraDetailContext } from '@pages/cameras/hook/CameraDetailsProvider';
import useMileSightSP111 from '@pages/cameras/hook/useMilesightSP111';
import { useEffect } from 'react';
import {
    DataSectionHasSubItem,
    SectionHasSubItemHeader,
    SectionNotSubItemStatus,
} from '../../../ptz/milesight/components/BasicInfoMilesightCameraPTZ';

const SP111LimitModeMapping: { [key in LimitMode]: string } = {
    [LimitMode.Manual]: 'Manual Limit',
    [LimitMode.Scan]: 'Scan Limit',
};

const enableSP111LimitMapping: { [key in LimitEnable]: string } = {
    [LimitEnable.No]: 'No',
    [LimitEnable.Yes]: 'Yes',
};

const manualLimitStatusMapping: { [key in LimitStatus]: string } = {
    [LimitStatus.NotLimited]: 'Not Limited',
    [LimitStatus.Limited]: 'Limited',
};

const manualLimitedMapping: { [key in Limited]: string } = {
    [Limited.EnableLeft]: 'Enable Left',
    [Limited.EnableRight]: 'Enable Right',
    [Limited.EnableDown]: 'Enable Down',
    [Limited.EnableUp]: 'Enable Up',
};

export default function SP111_LimitsMilesightsCameraSP111() {
    const handleEdit = () => {
        console.log('Edit button clicked');
    };

    const { camera, filteredCamera } = useCameraDetailContext();

    const { SP111Limit, isLoadingSP111Limit } = useMileSightSP111({
        filteredCamera,
        cameraSP111: camera?.SP111CameraId!,
    });

    const statusList_SP111limits: DataSectionHasSubItem[] = [
        {
            label: 'Limit mode:',
            value: (
                <LoadingTextSkeleton
                    conditions={isLoadingSP111Limit}
                    value={SP111LimitModeMapping[SP111Limit?.Mode!]}
                    loadingStyle={{
                        width: '50%',
                    }}
                />
            ),
        },
        {
            label: 'Mod status:',
            value: (
                <LoadingTextSkeleton
                    conditions={isLoadingSP111Limit}
                    value={manualLimitStatusMapping[SP111Limit?.ManualLimitStatus! ?? SP111Limit?.ScanLimitStatus!]}
                    loadingStyle={{
                        width: '50%',
                    }}
                />
            ),
        },
        {
            label: 'Enable:',
            value: (
                <LoadingTextSkeleton
                    conditions={isLoadingSP111Limit}
                    value={enableSP111LimitMapping[SP111Limit?.ManualLimitEnable! ?? SP111Limit?.ScanLimitEnable!]}
                    loadingStyle={{
                        width: '50%',
                    }}
                />
            ),
        },
    ];

    return (
        <Stack id="SP111_limits" border={'1px solid #E4E7EC'} borderRadius={2} flex={1}>
            {/* SP111 Limits Information */}
            <SectionHasSubItemHeader id="" title="SP111 Limits" onEdit={handleEdit} />

            <Divider
                orientation="vertical"
                sx={{
                    borderBottomWidth: 1,
                    borderColor: '#E4E7EC',
                    mx: 2,
                }}
            />

            <Stack spacing={2} padding={2} borderRadius={1} margin={1}>
                {statusList_SP111limits.map((status, index) => (
                    <SectionNotSubItemStatus key={index} label={status.label} value={status.value} />
                ))}
            </Stack>
        </Stack>
    );
}
